export default {
  storageName: 'arenaxstoragedev',
  arenaUrl: 'https://arena51-dev.arkadiumarena.com',
  apiUrl: 'https://arenax-api-admin-dev.arkadiumhosted.com/api/v1',
  gameApiUrl: 'https://game-api-fd-dev.arkadiumhosted.com',
  sentryDsn: 'https://0491ba8df8cb1ff95140abae42591b70@sentry.arkadiumhosted.com/61',
  sentryEnvironment: 'feature-dev',
  msalConfig: {
    auth: {
      authority: 'https://login.microsoftonline.com/7945008c-5c1b-42a9-a1c3-7f3d3642da94',
      clientId: 'cb5953d1-b74b-40b3-9e6a-742c0554023a',
    },
    cache: {
      cacheLocation: 'localStorage'
    },
  }
};

